import {COOPERATION_FORM_ROUTE} from "../../routes/route-path";
import React from "react";
import {Navigate} from "react-router-dom";

export const CFPage = () => {
    return <Navigate to={COOPERATION_FORM_ROUTE}/>;
}